import React, { useRef, useState, useCallback } from "react";

// Reusable Before / After image slider. Works with mouse and touch.
export const BeforeAfterSlider = ({ before, after, beforeLabel = "Before", afterLabel = "After", className = "" }) => {
  const containerRef = useRef(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const update = useCallback((clientX) => {
    const el = containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    let p = ((clientX - rect.left) / rect.width) * 100;
    p = Math.max(0, Math.min(100, p));
    setPos(p);
  }, []);

  const onDown = (e) => {
    dragging.current = true;
    update(e.touches ? e.touches[0].clientX : e.clientX);
  };
  const onMove = (e) => {
    if (!dragging.current) return;
    update(e.touches ? e.touches[0].clientX : e.clientX);
  };
  const onUp = () => { dragging.current = false; };

  return (
    <div
      ref={containerRef}
      data-testid="before-after-slider"
      className={`relative overflow-hidden select-none cursor-ew-resize ${className}`}
      onMouseDown={onDown}
      onMouseMove={onMove}
      onMouseUp={onUp}
      onMouseLeave={onUp}
      onTouchStart={onDown}
      onTouchMove={onMove}
      onTouchEnd={onUp}
    >
      <img src={after} alt="After" className="absolute inset-0 w-full h-full object-cover pointer-events-none" draggable="false" />
      <span className="absolute top-4 right-4 z-10 text-[10px] tracking-[0.2em] uppercase bg-black/60 text-white px-3 py-1.5 backdrop-blur-sm">{afterLabel}</span>
      <div className="absolute inset-0 h-full overflow-hidden pointer-events-none" style={{ width: `${pos}%` }}>
        <img src={before} alt="Before" className="absolute inset-0 h-full object-cover max-w-none" style={{ width: containerRef.current ? containerRef.current.offsetWidth : "100%" }} draggable="false" />
        <span className="absolute top-4 left-4 text-[10px] tracking-[0.2em] uppercase bg-white/80 text-black px-3 py-1.5 backdrop-blur-sm">{beforeLabel}</span>
      </div>
      <div className="absolute top-0 bottom-0 z-20 pointer-events-none" style={{ left: `${pos}%`, transform: "translateX(-50%)" }}>
        <div className="w-[2px] h-full bg-white shadow-[0_0_20px_rgba(0,0,0,0.5)]" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white shadow-lg flex items-center justify-center">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0A0A0A" strokeWidth="2"><path d="M8 7l-5 5 5 5M16 7l5 5-5 5"/></svg>
        </div>
      </div>
    </div>
  );
};

export default BeforeAfterSlider;
